module.exports = __webpack_public_path__ + "img/Group 427320601.736bb601.png";